module.exports = __webpack_public_path__ + "static/media/arrow-ricerca.5b48f39f.svg";